import $ from 'jquery'

class FormSearch extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-form-search', FormSearch, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/FormSearch/script.js